import { render, staticRenderFns } from "./AnimatedProceedButton.vue?vue&type=template&id=5dd449ae&scoped=true"
import script from "./AnimatedProceedButton.vue?vue&type=script&lang=js"
export * from "./AnimatedProceedButton.vue?vue&type=script&lang=js"
import style0 from "./AnimatedProceedButton.vue?vue&type=style&index=0&id=5dd449ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd449ae",
  null
  
)

export default component.exports